import type { ProgramEventContentObjectDetail } from 'models';
import { CommentsWrapper } from 'features/feed';

type P = {
  eventContentObject: ProgramEventContentObjectDetail;
};

const ProgramEventDetailComments = ({ eventContentObject }: P) => (
  <CommentsWrapper card contentObject={eventContentObject} />
);

export default ProgramEventDetailComments;
